var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-form',{attrs:{"editable":true,"register":true,"input":null},on:{"close":_vm.close_dialog,"submit":_vm.submit_registration}})}
var staticRenderFns = []

export { render, staticRenderFns }